<template>
  <div id="pcb-info-form">
    <Form ref="pcbInfoForm" :model="formData" label-position="top">
      <Row :gutter="32" class="align-items-center">
        <Col span="12">
        <FormItem prop="name" :label="$t('pcb.form.board_name')" required>
          <Input v-model="formData.name" :placeholder="$t('pcb.form.board_name_placeholder')"></Input>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem prop="chinese_name" :label="$t('pcb.form.chinese_name')">
          <Input v-model="formData.chinese_name"></Input>
        </FormItem>
        </Col>
        <Col span="20">
        <FormItem prop="specification" :label="$t('pcb.form.specification')" required>
          <Input v-model="formData.specification" :placeholder="$t('pcb.form.specification')"></Input>
        </FormItem>
        </Col>
        <Col span="4">
        <FormItem :label="$t('part.info.unit')" prop="unit" required>
          <Select v-model="formData.unit">
            <Option v-for="unit in units" :value="unit.value" :key="unit.value">{{ $t(unit.label) }}</Option>
          </Select>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem :label="$t('pcb.form.description')">
          <Input v-model="formData.description" type="textarea" :placeholder="$t('pcb.form.description_placeholder')"
            :rows="8"></Input>
        </FormItem>
        </Col>
      </Row>
      <Row :gutter="32">
        <Col span="8">
        <FormItem :label="$t('part.info.moderation')" prop="reviewed" required>
          <Select v-model="formData.reviewed" transfer>
            <Option v-for="item in moderationStates" :value="item.value" :key="item.value">
              {{ item.label }}
              <span style="float: right; font-size: 90%">{{ item.desc }}</span>
            </Option>
          </Select>
        </FormItem>
        </Col>
        <Col span="8">
        <!-- lifecylce status -->
        <FormItem :label="$t('part.info.lifecycle_status')" prop="lifecycle_status" required>
          <Select v-model="formData.lifecycle_status" transfer>
            <OptionGroup :label="$t('part.info.lifecycle_status_standard')">
              <Option v-for="item in lifecycleStatus.standard" :value="item.value" :key="item.value">{{ item.label }}
              </Option>
            </OptionGroup>
            <OptionGroup :label="$t('part.info.lifecycle_status_custom')">
              <Option v-for="item in lifecycleStatus.custom" :value="item.value" :key="item.value">{{ item.label }}
              </Option>
            </OptionGroup>
          </Select>
        </FormItem>
        <!-- lifecycle status field end -->
        </Col>

        <Col span="8">
        <!-- require quality exam field -->
        <FormItem :label="$t('part.info.require_quality_exam.field_name')" prop="require_quality_exam" required>
          <Select v-model="formData.require_quality_exam" transfer>
            <Option :value="0">{{ $t('part.info.require_quality_exam.no') }}</Option>
            <Option :value="1">{{ $t('part.info.require_quality_exam.yes') }}</Option>
          </Select>
        </FormItem>
        <!-- require quality exam field end -->
        </Col>
      </Row>
      <Row :gutter="32">
        <Col offset="16" span="8" class="text-align-right" style="padding-top:24px;">
        <Button v-if="!isNew" type="text" @click="showChangeLog = true">{{ $t('part.component_change_histories')
        }}</Button>
        <Button type="primary" @click="handleSubmit()" :loading="saving">{{ $t('save') }}</Button>
        </Col>
      </Row>
    </Form>
    <Modal id="component-change-log" v-model="showChangeLog" :title="$t('part.component_change_histories')" width="80%"
      mask>
      <PartAuditChangeLog v-if="!isNew && pcbInfo" :component-type="componentType" :id="pcbInfo.id">
      </PartAuditChangeLog>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import PartAuditChangeLog from '../../part/components/part-audit-changelog'

export default {
  name: 'PcbInfoForm',
  props: {
    pcbInfo: {
      type: Object,
      required: false
    },
    isNew: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    PartAuditChangeLog
  },
  mounted() {
    if (!this.isNew) {
      this.formData = _.cloneDeep(this.pcbInfo)
    }
  },
  data() {
    return {
      formData: {
        name: '',
        chinese_name: '',
        specification: '',
        description: '',
        unit: ''
      },
      moderationStates: [
        { value: 0, label: 'Draft', desc: 'May have problem to be referenced.' },
        { value: 1, label: 'Reviewed', desc: 'OK to be referenced.' },
        { value: -1, label: 'Invalid', desc: 'Stop using it immediately.' }
      ],
      lifecycleStatus: {
        standard: [
          { value: 'active', label: 'Active' },
          { value: 'nrnd', label: 'Not recommended for new designs (NRND)' },
          { value: 'eol', label: 'End of life (EOL)' }
        ],
        custom: [
          { value: 's0', label: 'S0 - Concept/Design' },
          { value: 's1', label: 'S1 - Prototyping (Functional testing)' },
          { value: 's2', label: 'S2 - Prototyping (Manufacturable testing)' },
          { value: 's3', label: 'S3 - NPI' },
          { value: 's4', label: 'S4 - Pilot run' },
          { value: 's5', label: 'S5 - Volume production' },
          { value: 's6', label: 'S6 - SCM' }
        ]
      },
      saving: false,
      showChangeLog: false,
      componentType: 'circuit-board',
      units: [
        { value: 'pcs', label: "part.info.units.pcs" },
        { value: 'batch', label: "part.info.units.batch" },
        { value: 'unit', label: "part.info.units.unit" },
        { value: 'set', label: "part.info.units.set" },
        { value: 'suit', label: "part.info.units.suit" },
        { value: 'roll', label: "part.info.units.roll" },
        { value: 'kg', label: "part.info.units.kg" }
      ]
    }
  },
  methods: {
    ...mapActions([
      'updatePcb',
      'createPcb'
    ]),
    handleSubmit() {
      this.$refs['pcbInfoForm'].validate(valid => {
        if (valid) {
          this.saving = true

          let actionReq = !this.isNew
            ? this.updatePcb({ id: this.formData.id, data: this.formData })
            : this.createPcb(this.formData)

          actionReq.then(resp => {
            this.$Message.success(this.$t('save_success_message'))

            if (this.isNew) {
              this.$router.push({ name: 'menu.pcb.edit', params: { partId: resp.data.id } })
            }
          }).finally(() => { this.saving = false })
        }
      })
    }
  },
  watch: {
    pcbInfo() {
      this.formData = _.cloneDeep(this.pcbInfo)
    }
  }
}
</script>
